import React from 'react'

export type PillTone = 'success' | 'warning' | 'info'

export default function StatusPill({ label, tone = 'info' }: { label: string; tone?: PillTone }) {
  const toneClass =
    tone === 'success'
      ? 'bg-emerald-300 text-neutral-950'
      : tone === 'warning'
      ? 'bg-yellow-300 text-neutral-950'
      : 'bg-blue-300 text-neutral-950'

  return (
    <span className={`inline-block rounded-full px-2.5 py-1 text-xs font-bold tracking-wide uppercase ${toneClass}`}>
      {label}
    </span>
  )
}

